import React from 'react'

export default function LinkedinIcon({w,h}) {
  return (
    <svg className='animate-contact'
    xmlns="http://www.w3.org/2000/svg"
    width={w}
    height={h}
    enableBackground="new 0 0 512 512"
    viewBox="0 0 176 176"
  >
    <g xmlns="http://www.w3.org/2000/svg" data-name="Layer 2">
      <g>
        <rect
          width="176"
          height="176"
          fill="#0077b5"
          data-original="#0077b5"
          rx="24"
        ></rect>
        <g fill="#fff">
          <path
            d="M63.4 48a15 15 0 11-15-15 15 15 0 0115 15zM60 73v66.27a3.71 3.71 0 01-3.71 3.73H40.48a3.71 3.71 0 01-3.72-3.72V73a3.72 3.72 0 013.72-3.72h15.81A3.72 3.72 0 0160 73zM142.64 107.5v32.08a3.41 3.41 0 01-3.42 3.42h-17a3.41 3.41 0 01-3.42-3.42v-31.09c0-4.64 1.36-20.32-12.13-20.32-10.45 0-12.58 10.73-13 15.55v35.86A3.42 3.42 0 0190.3 143H73.88a3.41 3.41 0 01-3.41-3.42V72.71a3.41 3.41 0 013.41-3.42H90.3a3.42 3.42 0 013.42 3.42v5.78c3.88-5.82 9.63-10.31 21.9-10.31 27.18 0 27.02 25.38 27.02 39.32z"
            data-original="#ffffff"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  )
}
